import { SearchField } from '@machobear/design-system'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { Filter, SearchIcon } from '@/components/icons'

type Props = {
  onSearch: (e: any) => void
  filters: string[]
  value: string
  onFilter: Dispatch<SetStateAction<string[]>>
  id: string
}

const ListingsSearchField = ({ onSearch, onFilter, filters, value, id }: Props) => {
  const { t } = useTranslation()
  const availableFilters: Record<string, { label: string; value: string }> = {
    all: { label: t('l.settings.view.auto_reply_listings_all.filter', 'All'), value: 'all' },
    rented: {
      label: t('l.settings.view.auto_reply_listings_rented.filter', 'Rented'),
      value: 'rented'
    },
    draft: {
      label: t('l.settings.view.auto_reply_listings_draft.filter', 'Draft'),
      value: 'draft'
    },
    hidden: {
      label: t('l.settings.view.auto_reply_listings_hidden.filter', 'Hidden'),
      value: 'hidden'
    },
    pending: {
      label: t('l.settings.view.auto_reply_listings_pending.filter', 'Pending'),
      value: 'pending'
    },
    published: {
      label: t('l.settings.view.auto_reply_listings_published.filter', 'Published'),
      value: 'published'
    },
    upcoming: {
      label: t('l.settings.view.auto_reply_listings_upcoming.filter', 'Upcoming'),
      value: 'upcoming'
    }
  }
  const handleFilter = (selectedFilter: { label: string; value: string }) => {
    const result =
      selectedFilter.value === 'all'
        ? []
        : filters.includes(selectedFilter.value)
        ? filters.filter(item => item !== selectedFilter.value)
        : [...filters, selectedFilter.value]

    onFilter(result)
  }
  const selectedFilters = filters
    ? filters.map(item => ({ label: availableFilters[item].label, value: item }))
    : undefined
  return (
    <SearchField
      value={value}
      label={t('common.search', 'Search')}
      id={id}
      onChange={onSearch}
      icon={<SearchIcon id="search" />}
      actionIcon={<Filter />}
      actionLabel={t('l.settings.view.auto_reply_listings_filter.label', 'Filter')}
      filters={Object.values(availableFilters)}
      onFilter={handleFilter}
      selectedFilters={selectedFilters}
    />
  )
}

export default ListingsSearchField
